import { TargetTabs } from '@atlassiansox/cross-flow-extensions/types';
import { Editions } from '@atlassiansox/cross-flow-extensions/types';
import type { TargetType } from '@atlassiansox/cross-flow-support/cross-flow-base-types';

import { getParams } from '@townsquare/routing/utils';

interface CrossFlowWACInitParams {
	billingMode?: 'legacy';
	edition?: Editions;
	migrationSourceUuid?: string;
	sourceComponent?: string;
	sourceContext?: string;
	startTrialCloudId?: string;
	startTrialProduct?: TargetType;
	targetTab?: TargetTabs;
	templateId?: string;
	forceConfirmationScreen?: string;
}

export function getCrossFlowParams(): CrossFlowWACInitParams {
	return getParams(
		'startTrialCloudId',
		'startTrialProduct',
		'edition',
		'migrationSourceUuid',
		'billingMode',
		'sourceContext',
		'targetTab',
		'sourceComponent',
		'templateId',
		'forceConfirmationScreen',
	);
}

export function isCrossFlowing(): boolean {
	const crossFlowParams = getCrossFlowParams();
	return Object.entries(crossFlowParams).length > 0;
}
